import { Sparkles, Send } from "lucide-react";

export default function RecentActivityRail({ activity = [], loading = false }) {
  return (
    <aside className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 h-fit xl:sticky xl:top-24 xl:self-start">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="text-lg font-semibold text-slate-900">
            Recent Activity
          </h2>

          <p className="text-sm text-slate-500">What RevUShield has handled.</p>
        </div>

        <Sparkles size={20} className="text-indigo-600" />
      </div>

      {loading ? (
        <p className="text-sm text-slate-500">Loading activity...</p>
      ) : activity.length > 0 ? (
        <div className="space-y-4">
          {activity.map((item, index) => {
            const Icon = item.icon;

            return (
              <div key={`${item.title}-${index}`} className="flex gap-3">
                <div className="mt-0.5 h-9 w-9 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center shrink-0">
                  <Icon size={18} />
                </div>

                <div className="min-w-0">
                  <p className="text-sm font-semibold text-slate-900">
                    {item.title}
                  </p>

                  <p className="text-sm text-slate-500">{item.description}</p>

                  <p className="text-xs text-slate-400 mt-1">{item.time}</p>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
          <p className="text-sm text-slate-600">
            Activity will appear here as reviews sync and responses are created.
          </p>
        </div>
      )}

      <div className="mt-5 rounded-xl bg-indigo-50 border border-indigo-100 p-4">
        <div className="flex items-center gap-2 text-indigo-700 font-semibold text-sm">
          <Send size={16} />
          Automation status
        </div>

        <p className="text-sm text-indigo-700 mt-1">
          RevUShield is monitoring reviews and preparing responses.
        </p>
      </div>
    </aside>
  );
}
